import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import Tile from 'ol/Tile';
import ImageTile from 'ol/ImageTile';

/**
 * The app-wide Referrer-Policy is same-origin, so tile requests would carry no
 * Referer at all. OSM answers those with a "403 Access blocked" placeholder
 * image instead of a map. A per-image referrerPolicy overrides the document
 * policy, which identifies the app to tile servers without relaxing the header
 * for the rest of the application.
 */
function loadTile(tile: Tile, src: string): void {
    const image = (tile as ImageTile).getImage() as HTMLImageElement;
    image.referrerPolicy = 'strict-origin-when-cross-origin';
    image.src = src;
}

/**
 * OpenStreetMap raster basemap, the only one: it needs no API key. Its tile
 * usage policy requires the attribution and the Referer set above, and gives no
 * availability guarantee.
 */
export function createBasemapLayer(): TileLayer<XYZ> {
    return new TileLayer({
        // Lets _Map.scss darken the basemap alone, never the vector layers or popups
        className: 'map-basemap',
        source: new XYZ({
            url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
            attributions: ['© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'],
            maxZoom: 19,
            crossOrigin: 'anonymous',
            tileLoadFunction: loadTile,
        }),
    });
}
